import * as React from 'react';
export default function getRanges(_ref) {
  var prefixCls = _ref.prefixCls,
      _ref$rangeList = _ref.rangeList,
      rangeList = _ref$rangeList === void 0 ? [] : _ref$rangeList,
      _ref$components = _ref.components,
      components = _ref$components === void 0 ? {} : _ref$components,
      needConfirmButton = _ref.needConfirmButton,
      onNow = _ref.onNow,
      onOk = _ref.onOk,
      onCancel = _ref.onCancel,
      okDisabled = _ref.okDisabled,
      showNow = _ref.showNow,
      locale = _ref.locale,
      _ref$isRange = _ref.isRange,
      isRange = _ref$isRange === void 0 ? false : _ref$isRange;
  var presetNode;
  var okNode;
  var cancelNode;

  if (rangeList.length) {
    var Item = components.rangeItem || 'span';
    presetNode = /*#__PURE__*/React.createElement(React.Fragment, null, rangeList.map(function (_ref2) {
      var label = _ref2.label,
          onClick = _ref2.onClick,
          onMouseEnter = _ref2.onMouseEnter,
          onMouseLeave = _ref2.onMouseLeave;
      return /*#__PURE__*/React.createElement("li", {
        key: label,
        className: "".concat(prefixCls, "-preset")
      }, /*#__PURE__*/React.createElement(Item, {
        onClick: onClick,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave
      }, label));
    }));
  }

  if (needConfirmButton) {
    var OkButton = components.okButton || 'button';
    var CancelButton = components.cancelButton || 'button';

    if (onNow && !presetNode && showNow !== false) {
      presetNode = /*#__PURE__*/React.createElement("li", {
        className: "".concat(prefixCls, "-now")
      }, /*#__PURE__*/React.createElement("a", {
        className: "".concat(prefixCls, "-now-btn"),
        onClick: onNow
      }, locale.now));
    }

    okNode = needConfirmButton && /*#__PURE__*/React.createElement("span", {
      className: "".concat(prefixCls, "-ok")
    }, /*#__PURE__*/React.createElement(OkButton, {
      disabled: okDisabled,
      onClick: onOk
    }, locale.ok));
    cancelNode = needConfirmButton && /*#__PURE__*/React.createElement("span", {
      className: "".concat(prefixCls, "-cancel")
    }, /*#__PURE__*/React.createElement(CancelButton, {
      onClick: onCancel
    }, locale.cancel));
  }

  if (!presetNode && !okNode) {
    return null;
  }

  return /*#__PURE__*/React.createElement("ul", {
    className: "".concat(prefixCls, "-ranges")
  }, presetNode, /*#__PURE__*/React.createElement("li", {
    className: "".concat(prefixCls, "-btns")
  }, okNode, isRange ? cancelNode : null));
}